export default __webpack_public_path__ + "static/media/bisola.1f44cda0.png";